import { DocumentationPage } from './_article.jsx';
export default function BillingPage({
  article,
  articles
}) {
  return <DocumentationPage article={article} articles={articles} />;
}